import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { NAV_BAR_HEIGHT } from 'foundations-components/transitional/constants';
import { jsx as _jsx } from "react/jsx-runtime";
function LoadingScreen() {
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    minBlockSize: `calc(100vh - ${NAV_BAR_HEIGHT})`,
    "data-test-id": "loading-screen",
    "aria-busy": true,
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true
    })
  });
}
export default LoadingScreen;